import { Component, OnInit, Input } from '@angular/core';
import { CommonService } from '../../../services/common/common.service';

@Component({
  selector: 'performer-map',
  templateUrl: './performer-map.component.html',
  styleUrls: ['./performer-map.component.scss'],
})
export class PerformerMapComponent implements OnInit {
  @Input('graphData') graphData: any;
  widgetTitle = "";
  performerConfig : any = {};
  color = 'red';
  performerdata = [];

  constructor(private commonService: CommonService) { }


  ngOnChanges(){


  }


  ngOnInit() {



    if(this.graphData.udf && this.graphData.udf.performerConfig){
      this.performerConfig = this.graphData.udf.performerConfig;
    }else{
      this.performerConfig = {
        topOrBottom:"top",
        noOfPerformers:"5"
      }
    }


    if(this.graphData.dataFilter && this.graphData.dataFilter.length > 0){
      //console.log(JSON.stringify(this.graphData.dataFilter));
      this.widgetTitle = this.graphData.title;
      //Single filter for performer
      let kpiConfig = typeof this.graphData.udf.kpiNumberConfig[0] === 'undefined' ? {} : this.graphData.udf.kpiNumberConfig[0];
      let numberFormat = kpiConfig.kpiNumberFormat ? kpiConfig.kpiNumberFormat : 0;
      let value;
      let dataFilter = this.graphData.dataFilter;
      let dataForWidget = this.sortData(dataFilter);

      dataForWidget.forEach((element,i) => {
        if (numberFormat == "-1") {
          value = this.commonService.shortNumberFormat(element.data[0].value);
        } else {
          numberFormat = !numberFormat ? 0 : numberFormat;
          value = element.data && element.data.length > 0 ? parseFloat(element.data[0].value) : 0.00;
          value = value.toFixed(numberFormat)
        }

        if(element.isThousandSeperator){
          value = this.commonService.formatNumberString(value, true);
        }

          let pdata = {};
          pdata["label"] = element.label;
          // value = Number.parseFloat(element.data[0].value).toFixed(2);
          pdata["value"] = value;//element.data[0].value.toFixed();
          pdata["color"] = element.color;
          pdata["style"] = {"height":"100%","background":element.color,"width":element.data[0].valueper+'%'}
          this.performerdata.push(pdata);
      });
    }
  }





  sortData (df) {
    df = df.map(o => {
      if(o.data.length == 0){
        o.data = [{value: 0}]
      }
      return o;
    });

    let SortedDataFilter = [];
    if(this.performerConfig.topOrBottom == "top") {
      SortedDataFilter = df.sort(function(o1,o2){return o2.data[0].value-o1.data[0].value});
      SortedDataFilter.length = (this.performerConfig.noOfPerformers > SortedDataFilter.length) ?  SortedDataFilter.length : this.performerConfig.noOfPerformers;
      SortedDataFilter.forEach((element,i) => {
        try{
          SortedDataFilter[i].data[0].valueper = SortedDataFilter[i].data[0].value / SortedDataFilter[0].data[0].value * 100;
        }catch(e){
          SortedDataFilter[i].data = [{valueper: 0, value: 0}];
        }
     });
    } else {
      SortedDataFilter = df.sort(function(o1,o2){return o1.data[0].value-o2.data[0].value});
      SortedDataFilter.length = (this.performerConfig.noOfPerformers > SortedDataFilter.length) ?  SortedDataFilter.length : this.performerConfig.noOfPerformers;
      SortedDataFilter.forEach((element,i) => {
        try{
          SortedDataFilter[i].data[0].valueper = SortedDataFilter[i].data[0].value / SortedDataFilter[SortedDataFilter.length-1].data[0].value * 100;
        }catch(e){
          SortedDataFilter[i].data = [{valueper: 0, value: 0}];
        }
     });
    }
  return SortedDataFilter;
  }

}



// WEBPACK FOOTER //
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/shared/components/graphs/performer-map/performer-map.component.ts